export default __webpack_public_path__ + "static/media/single-project-page-05-img-05.6ec01421.jpg";